import { render, staticRenderFns } from "./TabsNote.vue?vue&type=template&id=42f121e8&scoped=true&"
import script from "./TabsNote.vue?vue&type=script&lang=js&"
export * from "./TabsNote.vue?vue&type=script&lang=js&"
import style0 from "./TabsNote.vue?vue&type=style&index=0&id=42f121e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f121e8",
  null
  
)

export default component.exports